/**
 * Client-side Task Intelligence provider. The real provider calls the
 * `task-intelligence` edge function (which holds the model key server-side —
 * never in the browser); analyzeBrief() accepts an injected provider so
 * tests and the eval suite can run without a live model.
 */
import { supabase } from "../supabase";

function invokeErrorMessage(error, data) {
  if (data?.error) return String(data.error);
  if (error?.message) return error.message;
  return "Task Intelligence request failed.";
}

/**
 * @param {{ briefText: string, referenceDate: string, projectName: string,
 *   existingTasks: object[], members: object[], locations: object[] }} request
 * @returns {Promise<{ drafts: object[], notes: string[] }>}
 */
export async function callTaskIntelligenceEdgeFunction(request) {
  const { data, error } = await supabase.functions.invoke("task-intelligence", {
    body: request,
  });
  if (error || data?.error) {
    const err = new Error(invokeErrorMessage(error, data));
    err.code = data?.code || error?.code || "task_intelligence_error";
    throw err;
  }
  return {
    drafts: Array.isArray(data?.drafts) ? data.drafts : [],
    notes: Array.isArray(data?.notes) ? data.notes : [],
  };
}

export function createDefaultTaskIntelligenceProvider() {
  return { id: "task-intelligence-edge-function", analyze: callTaskIntelligenceEdgeFunction };
}
